export const getMondayOfWeek = (date: Date): Date => {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  const day = d.getUTCDay();
  const diff = d.getUTCDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), diff));
  return monday;
};

export const isInWeek = (date: Date, monday: Date): boolean => {
  const dateNormalized = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  );
  const mondayNormalized = new Date(
    Date.UTC(monday.getUTCFullYear(), monday.getUTCMonth(), monday.getUTCDate())
  );
  const fridayNormalized = new Date(mondayNormalized);
  fridayNormalized.setUTCDate(fridayNormalized.getUTCDate() + 4);

  return (
    dateNormalized.getTime() >= mondayNormalized.getTime() &&
    dateNormalized.getTime() <= fridayNormalized.getTime()
  );
};

export const getWeekDays = (monday: Date): Date[] => {
  const weekdays: Date[] = [];
  for (let i = 0; i < 5; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    day.setHours(0, 0, 0, 0);
    weekdays.push(day);
  }
  return weekdays;
};

export const formatWeekLabel = (weekdays: Date[]): string => {
  const formatDate = (date: Date) => {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return `${day} ${month}`;
  };
  return `${formatDate(weekdays[0])} - ${formatDate(weekdays[4])}`;
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const getLastEndedWeek = (): Date[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dayOfWeek = today.getDay();

  let daysToLastMonday = 0;
  if (dayOfWeek === 0) {
    daysToLastMonday = 6;
  } else if (dayOfWeek === 1) {
    daysToLastMonday = 7;
  } else {
    daysToLastMonday = dayOfWeek + 6;
  }

  const lastMonday = new Date(today);
  lastMonday.setDate(today.getDate() - daysToLastMonday);
  lastMonday.setHours(0, 0, 0, 0);

  return getWeekDays(lastMonday);
};

/**
 * Returns the week key (YYYY-MM-DD of Monday) for the last finished week.
 * Uses UTC to match useWeekManagement's key format (mood dates are normalized to UTC).
 */
export const getLastEndedWeekKey = (): string => {
  const now = new Date();
  const todayUTC = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  const dayOfWeek = todayUTC.getUTCDay();

  let daysToLastMonday = 0;
  if (dayOfWeek === 0) {
    daysToLastMonday = 6;
  } else if (dayOfWeek === 1) {
    daysToLastMonday = 7;
  } else {
    daysToLastMonday = dayOfWeek + 6;
  }

  const lastMonday = new Date(todayUTC);
  lastMonday.setUTCDate(todayUTC.getUTCDate() - daysToLastMonday);
  return lastMonday.toISOString().slice(0, 10);
};
